'use strict';

var _ = require('lodash');
var AdvancedHepTransformationService = function AdvancedHepTransformationService(configurationService, fpMarketConfigParsingService, momentService, featureToggleService, configurationParametersAdvancedService) {
  var HOST_CARRIER = configurationService.getHostCarrier();
  var BENCHMARK_CARRIER_FIELD_PREFIX = 'cabinCode';
  var CABIN_CAPACITIES_FIELD_PREFIX = 'cabinCapacities';
  var OPERATOR_NUMBER_PROPS = {
    noOfStop: true,
    minConnectionTime: true,
    maxConnectionTime: true
  };
  var OPERATOR_BOOLEAN_PROPS = {
    isPOCandPOS: true,
    isCodeShare: true,
    isTOD: true,
    isOneWay: true,
    isShiftShopping: true,
    isUseNGDS: true,
    isDynamicPricingAdj: true,
    isMlModelEnabled: true,
    isFareBrandEnabled: true
  };
  var RIA_METHOD_MAP = {
    MEDIAN: 'Median',
    WEIGHTED_AVERAGE: 'Weighted Avg'
  };
  var MARKET_CONFIG_SOURCE_METHOD_MAP = {
    ALL: 'All',
    WEB_FARES: 'Web Fares'
  };
  function getBenchmarkFieldName(cabin) {
    return BENCHMARK_CARRIER_FIELD_PREFIX + cabin;
  }
  function getCabinCapacitiesFieldName(cabin) {
    return CABIN_CAPACITIES_FIELD_PREFIX + '-' + cabin;
  }
  function getCarriersForCabins(benchmarkCarriers) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      result[getBenchmarkFieldName(cabin)] = getCarriersForCabin(benchmarkCarriers, cabin);
    }, {});
  }
  function getCarriersForCabin(benchmarkCarriers, cabin) {
    var carriersForCabin = _.find(benchmarkCarriers, function (obj) {
      return obj.attributes.cabinCode === cabin;
    });
    return _.isUndefined(carriersForCabin) ? null : carriersForCabin.properties.benchmarkCarriers;
  }
  function getMarketLevelCarriers(marketBenchmarkCarriers) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      result[getBenchmarkFieldName(cabin)] = marketBenchmarkCarriers;
    }, {});
  }
  function transformBlackoutDatesArray(propertyValue) {
    return _.map(propertyValue, function (row) {
      fpMarketConfigParsingService.splitParsedDate(row, 'start');
      fpMarketConfigParsingService.splitParsedDate(row, 'end');
      return row;
    });
  }
  function transformDTDBlackoutArray(propertyValue) {
    return _.map(propertyValue, function (row) {
      fpMarketConfigParsingService.splitParsedNumber(row, 'dtdCondition');
      return row;
    });
  }
  function transformBoolean(booleanValue) {
    return booleanValue ? 'Yes' : 'No';
  }
  function transformRiaMethod(riaMethod) {
    return RIA_METHOD_MAP[riaMethod];
  }
  function transformMarketConfigSource(source) {
    return MARKET_CONFIG_SOURCE_METHOD_MAP[source];
  }
  function transformMarketConfigProperties(properties, propKey) {
    addDefaultValuesToDisplay(properties);
    return _.transform(properties, function (result, propertyValue, key) {
      key = key.split('-').join('_');
      var newKey = [propKey, key].join('_');
      if (OPERATOR_NUMBER_PROPS[key]) {
        result[newKey] = propertyValue;
        fpMarketConfigParsingService.splitParsedNumber(result, newKey);
      } else if (OPERATOR_BOOLEAN_PROPS[key]) {
        result[newKey] = transformBoolean(propertyValue);
      } else if (key === 'riaMethod') {
        result[newKey] = transformRiaMethod(propertyValue);
      } else if (key === 'source') {
        result[newKey] = transformMarketConfigSource(propertyValue);
      } else if (key === 'blackoutDeptDateParams') {
        result[newKey] = transformBlackoutDatesArray(propertyValue);
      } else if (key === 'dtdBlackout') {
        result[newKey] = transformDTDBlackoutArray(propertyValue);
      } else {
        result[newKey] = propertyValue;
      }
      return result;
    }, {});
  }
  function addDefaultValuesToDisplay(properties) {
    if (featureToggleService.isEnabled('DYNAMIC_PRICING')) {
      if (!_.has(properties, 'isDynamicPricingAdj')) {
        properties.isDynamicPricingAdj = false;
      }
      if (!_.has(properties, 'dynamicPricingAdjLOSRanges') || _.isEmpty(properties['dynamicPricingAdjLOSRanges'])) {
        properties.dynamicPricingAdjLOSRanges = [{
          losStart: 0,
          losEnd: 330
        }];
      }
    }
    if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL')) {
      if (!_.has(properties, 'isMlModelEnabled')) {
        properties.isMlModelEnabled = false;
      }
    }
  }
  function getBenchmarkCarrierProperties(attrs, benchmarkCarriersHepList) {
    var marketCabinBenchmarks = _.filter(benchmarkCarriersHepList, function (obj) {
      return _.get(obj, ['attributes', 'marketOrigin']) === attrs.marketOrigin && _.get(obj, ['attributes', 'marketDestination']) === attrs.marketDestination;
    });
    var marketBenchmarks = _.find(marketCabinBenchmarks, function (obj) {
      return _.get(obj, ['attributes', 'cabinCode']) === undefined;
    });
    if (marketCabinBenchmarks.length === 1 && marketBenchmarks !== undefined) {
      return getMarketLevelCarriers(marketBenchmarks.properties.benchmarkCarriers);
    } else {
      return getCarriersForCabins(marketCabinBenchmarks);
    }
  }
  function transformFpMarketConfigType(attrs, props, meta, benchmarkCarriersHepList) {
    var propKey = _.chain(props).keys().head().value();
    var properties = props[propKey];
    var transformedProperties = transformMarketConfigProperties(properties, propKey);
    var benchmarkCarrierProperties = getBenchmarkCarrierProperties(attrs, benchmarkCarriersHepList);
    return _.assign(transformedProperties, attrs, meta, benchmarkCarrierProperties);
  }
  function transformCurtainRuleType(attrs, props, meta) {
    var availableCabins = configurationService.getCabins();
    var propKey = _.chain(props).keys().head().value();
    var generatedProp = _.mapKeys(props[propKey], function (obj, key) {
      key = key.split('-').join('_');
      return [propKey, key].join('_');
    });
    _.forEach(generatedProp['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName])) {
          var fieldName = getCabinCapacitiesFieldName(cabinName);
          cabinOptionsRow[fieldName] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName];
        }
      });
    });
    return _.assign(generatedProp, attrs, meta);
  }
  function transformFOTacticalFareIndexType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foTacticalFareIndexProperties = _.map(props[propKey], function (foTacticalFareIndexProperty) {
      foTacticalFareIndexProperty.percentageIndicator = percentageIndicatorToString(foTacticalFareIndexProperty);
      return foTacticalFareIndexProperty;
    });
    props[propKey] = foTacticalFareIndexProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareBrandAssignment(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOSurchargeManagement(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTacticalUserOverridesType(attrs, props, meta) {
    if (!_.isNil(props.cardinalityThresholdPercentageIndicator)) {
      props.cardinalityThresholdPercentageIndicator = props.cardinalityThresholdPercentageIndicator === true ? 'P' : 'A';
    }
    props.timeOfDayPropertiesList = [];
    if (!_.isNil(props.inboundTimeOfDayDefinition)) {
      props.timeOfDayPropertiesList = props.timeOfDayPropertiesList.concat(buildTimeOfDayProperties(props, 'inboundTimeOfDayDefinition'));
    }
    if (!_.isNil(props.outboundTimeOfDayDefinition)) {
      props.timeOfDayPropertiesList = props.timeOfDayPropertiesList.concat(buildTimeOfDayProperties(props, 'outboundTimeOfDayDefinition'));
    }
    if (!_.isNil(props.isCat12Prefiled)) {
      props.isCat12Prefiled = props.isCat12Prefiled.toString().toUpperCase();
    }
    props.proactiveBlackoutPropertiesList = [];
    if (!_.isNil(props.inboundProactiveBlackouts)) {
      props.proactiveBlackoutPropertiesList = props.proactiveBlackoutPropertiesList.concat(transformProactiveBlackoutsPropertiesToRender(props.inboundProactiveBlackouts, 'inboundProactiveBlackouts'));
    }
    if (!_.isNil(props.outboundProactiveBlackouts)) {
      props.proactiveBlackoutPropertiesList = props.proactiveBlackoutPropertiesList.concat(transformProactiveBlackoutsPropertiesToRender(props.outboundProactiveBlackouts, 'outboundProactiveBlackouts'));
    }
    delete props.inboundTimeOfDayDefinition;
    delete props.outboundTimeOfDayDefinition;
    delete props.inboundProactiveBlackouts;
    delete props.outboundProactiveBlackouts;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTacticalFareIndexPayload(row) {
    row.foTacticalFareIndexProperties = _.map(row.foTacticalFareIndexProperties, function (tacticalFareIndexProperty) {
      tacticalFareIndexProperty.percentageIndicator = percentageIndicatorToBoolean(tacticalFareIndexProperty);
      return tacticalFareIndexProperty;
    });
    return convertFOAttributeNameToAttributeName(row, 'foTacticalFareIndexProperties');
  }
  function transformFOFareBrandAssignmentPayload(row) {
    row.fareBrandAssignmentPropertiesList = _.map(row.fareBrandAssignmentPropertiesList, function (fareBrandAssignmentProperty) {
      fareBrandAssignmentProperty.fareBrand = fareBrandAssignmentProperty.fareBrand.toUpperCase();
      if (!_.isNil(fareBrandAssignmentProperty.inclusionFbcPattern)) {
        fareBrandAssignmentProperty.inclusionFbcPattern = fareBrandAssignmentProperty.inclusionFbcPattern.toUpperCase();
      }
      if (!_.isNil(fareBrandAssignmentProperty.exclusionFbcPattern)) {
        fareBrandAssignmentProperty.exclusionFbcPattern = fareBrandAssignmentProperty.exclusionFbcPattern.toUpperCase();
      }
      return fareBrandAssignmentProperty;
    });
    return convertFOAttributeNameToAttributeName(row, 'fareBrandAssignmentPropertiesList');
  }
  function transformFOTacticalFareDefinitionPayload(row) {
    _.forEach(row.tacticalFareDefinitionPropertiesList, function (tacticalFareBrandDefinitionProperty) {
      if ('RBD' === tacticalFareBrandDefinitionProperty.criteriaType.toUpperCase()) {
        tacticalFareBrandDefinitionProperty.value = tacticalFareBrandDefinitionProperty.value.toUpperCase();
      }
      if ((!_.isEmpty(tacticalFareBrandDefinitionProperty.compMatch) || !_.isNil(tacticalFareBrandDefinitionProperty.compMatch)) && 'PRIMARY' === tacticalFareBrandDefinitionProperty.grouping.toUpperCase()) {
        tacticalFareBrandDefinitionProperty.compMatch = null;
      }
    });
    return convertFOAttributeNameToAttributeName(row, 'tacticalFareDefinitionPropertiesList');
  }
  function transformFOTacticalFareDefinition(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTacticalUserOverridesPayload(row) {
    if (_.isNil(row.cardinalityThreshold) && _.isNil(row.fareValidityThreshold) && _.isNil(row.cardinalityThresholdPercentageIndicator) && _.isNil(row.isCat12Prefiled) && _.isNil(row.weekendDefinition) && _.isNil(row.advancePurchase) && _.isEmpty(row.timeOfDayPropertiesList) && _.isEmpty(row.proactiveBlackoutPropertiesList)) {
      throw new Error('Atleast one property must be defined.');
    }
    var regExp = new RegExp('^(\\d{0,2}(\\.\\d{1,2}?)?|100(.00?)?)$');
    if (_.isEmpty(row.cardinalityThresholdPercentageIndicator)) {
      row.cardinalityThresholdPercentageIndicator = null;
    }
    if (_.isEmpty(row.cardinalityThreshold)) {
      row.cardinalityThreshold = null;
    }
    if (!_.isNil(row.cardinalityThresholdPercentageIndicator) && _.isNil(row.cardinalityThreshold)) {
      throw new Error('Cardinality Threshold with percentage indicator should be non-empty.');
    }
    if (_.isNil(row.cardinalityThresholdPercentageIndicator) && !_.isNil(row.cardinalityThreshold)) {
      throw new Error('Cardinality Threshold with percentage indicator should be non-empty.');
    }
    if (!_.isNil(row.cardinalityThresholdPercentageIndicator)) {
      row.cardinalityThresholdPercentageIndicator = row.cardinalityThresholdPercentageIndicator === 'P';
    }
    if (!_.isNil(row.cardinalityThresholdPercentageIndicator) && !_.isNil(row.cardinalityThreshold)) {
      if (row.cardinalityThresholdPercentageIndicator && !row.cardinalityThreshold.toString().match(regExp)) {
        throw new Error('Cardinality Threshold Amount should be between 0 - 100 in case of percentage value');
      }
    }
    if (!_.isNil(row.foTacticalFareBrandUserOverrideProperties) && !_.isEmpty(row.foTacticalFareBrandUserOverrideProperties)) {
      _.forEach(row.foTacticalFareBrandUserOverrideProperties, function (foTacticalFareBrandUserOverrideProperty) {
        convertTimeOfDayDefinitionToString(row, foTacticalFareBrandUserOverrideProperty);
        transformProactiveBlackoutsProperties(foTacticalFareBrandUserOverrideProperty);
      });
    }
    if (!_.isNil(row.isCat12Prefiled)) {
      row.isCat12Prefiled = row.isCat12Prefiled === 'TRUE' || row.isCat12Prefiled === 'FALSE' ? JSON.parse(row.isCat12Prefiled.toLowerCase()) : undefined;
    }
    delete row.hostFareBrand;
    delete row.outboundWeekendDefinition;
    delete row.inboundWeekendDefinition;
    delete row.advancePurchase;
    delete row.timeOfDayPropertiesList;
    delete row.proactiveBlackoutPropertiesList;
    delete row.foSeasons;
    return convertFOAttributeNameToAttributeName(row);
  }
  function transformProactiveBlackoutsProperties(row) {
    var inboundProactiveBlackouts = [];
    var outboundProactiveBlackouts = [];
    _.forEach(row.proactiveBlackoutPropertiesList, function (proactiveBlackouts) {
      var proactiveBlackoutsProperties = {};
      proactiveBlackoutsProperties.begin = proactiveBlackouts['begin'].toISOString();
      proactiveBlackoutsProperties.end = proactiveBlackouts['end'].toISOString();
      if (proactiveBlackouts.inOrOutBoundType === 'IB') {
        inboundProactiveBlackouts.push(proactiveBlackoutsProperties);
      } else {
        outboundProactiveBlackouts.push(proactiveBlackoutsProperties);
      }
    });
    if (!_.isEmpty(inboundProactiveBlackouts)) {
      row.inboundProactiveBlackouts = inboundProactiveBlackouts;
    }
    if (!_.isEmpty(outboundProactiveBlackouts)) {
      row.outboundProactiveBlackouts = outboundProactiveBlackouts;
    }
    delete row.proactiveBlackoutPropertiesList;
  }
  function transformProactiveBlackoutsPropertiesToRender(properties, field) {
    var inOrOutBoundType = field === 'inboundProactiveBlackouts' ? 'IB' : 'OB';
    return _.map(properties, function (proactiveBlackoutProperties) {
      return {
        'inOrOutBoundType': inOrOutBoundType,
        'begin': momentService.of(proactiveBlackoutProperties.begin, momentService.FIELD.TRAVEL_DATE),
        'end': momentService.of(proactiveBlackoutProperties.end, momentService.FIELD.TRAVEL_DATE)
      };
    });
  }
  function transformFOBusinessRulesType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var benchmarkRuleProperties = [];
    _.forEach(props[propKey], function (benchmarkRuleProperty) {
      _.forEach(benchmarkRuleProperty.benchmarkCarriers, function (benchmarkCarriers) {
        var benchmarkRulePropertyRow = {};
        benchmarkRulePropertyRow.season = benchmarkRuleProperty.season;
        benchmarkRulePropertyRow.normalizationIndicator = benchmarkCarriers.normalizationIndicator;
        benchmarkRulePropertyRow.benchmarkCarrier = benchmarkCarriers.benchmarkCarrier;
        benchmarkRulePropertyRow.fareTypeIndicator = benchmarkCarriers.fareTypeIndicator;
        benchmarkRulePropertyRow.fareSource = benchmarkCarriers.competitorFareSource;
        benchmarkRulePropertyRow.hostFareBrand = benchmarkCarriers.hostFareBrand;
        benchmarkRulePropertyRow.hostRbd = benchmarkCarriers.hostRbd;
        benchmarkRulePropertyRow.competitorFareBrand = benchmarkCarriers.competitorFareBrand;
        benchmarkRulePropertyRow.strategy = benchmarkCarriers.strategy;
        benchmarkRulePropertyRow.amount = benchmarkCarriers.amount;
        benchmarkRulePropertyRow.benchmarkFareComponent = benchmarkCarriers.benchmarkFareComponent;
        benchmarkRulePropertyRow.percentageIndicator = percentageIndicatorToString(benchmarkCarriers);
        benchmarkRulePropertyRow.origin = attrs.origin;
        benchmarkRulePropertyRow.destination = attrs.destination;
        benchmarkRulePropertyRow.cabin = attrs.cabin;
        benchmarkRulePropertyRow.category = attrs.category;
        benchmarkRulePropertyRow.recommendationMatchType = benchmarkRuleProperty.recommendationMatchType;
        attrs.recommendationMatchType = benchmarkRuleProperty.recommendationMatchType;
        benchmarkRuleProperties.push(benchmarkRulePropertyRow);
      });
    });
    props[propKey] = benchmarkRuleProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function percentageIndicatorToBoolean(property) {
    return property.percentageIndicator === 'P';
  }
  function percentageIndicatorToString(property) {
    return property.percentageIndicator === true ? 'P' : 'A';
  }
  function transformFOPosAnalystMapType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var analystPosProperties = [];
    _.forEach(props[propKey], function (analystPosProperty) {
      var analystPosRow = {};
      analystPosRow.level = parseInt(analystPosProperty.level);
      analystPosRow.userName = buildCommaSeparatedUserNames(analystPosProperty.approversList);
      analystPosRow.pos = attrs.pos;
      analystPosProperties.push(analystPosRow);
    });
    props[propKey] = analystPosProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function buildCommaSeparatedUserNames(approversList) {
    return _.chain(approversList).map('userName').value().join(',');
  }
  function transformFOPosAnalystMapPayload(row) {
    var analystPosProperties = [];
    _.forEach(row.foAnalystPosMappingProperties, function (analystPosProperty) {
      var property = {};
      property.level = parseInt(analystPosProperty.level);
      property.approversList = buildApproversList(analystPosProperty.userName);
      analystPosProperties.push(property);
    });
    row.foAnalystPosMappingProperties = analystPosProperties;
    return row;
  }
  function buildApproversList(userNames) {
    var approvers = [];
    approvers.push({
      userName: userNames
    });
    return approvers;
  }
  function transformAttributeNameToFOAttributeName(attrs, props, meta) {
    if (!_.isNil(attrs) && !_.isNil(attrs.cabin)) {
      attrs.foCabin = attrs.cabin;
    }
    if (!_.isNil(attrs) && !_.isNil(attrs.carrier)) {
      attrs.foCarrier = attrs.carrier;
    }
    return _.assign(props, attrs, meta);
  }
  function transformFOUpSellBuyDownConfig(attrs, props, meta) {
    if (!_.isNil(props.upSellPercentageIndicator)) {
      props.upSellPercentageIndicator = props.upSellPercentageIndicator === true ? 'P' : 'A';
    }
    if (!_.isNil(props.buyDownPercentageIndicator)) {
      props.buyDownPercentageIndicator = props.buyDownPercentageIndicator === true ? 'P' : 'A';
    }
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function validateFOUpSellBuyDownConfigPayloadBeforeSave(row) {
    var regExp = new RegExp('^(\\d{0,2}(\\.\\d{1,2}?)?|100(.00?)?)$');
    if (_.isNil(row.upSellPercentageIndicator) && _.isNil(row.buyDownPercentageIndicator) && _.isNil(row.buyDownAmount) && _.isNil(row.upSellAmount)) {
      throw new Error('Atleast one property should be non-empty.');
    }
    if (_.isNil(row.buyDownPercentageIndicator) && !_.isNil(row.buyDownAmount)) {
      throw new Error('BuyDown % Indicator should be non-empty.');
    }
    if (_.isNil(row.upSellPercentageIndicator) && !_.isNil(row.upSellAmount)) {
      throw new Error('UpSell % Indicator should be non-empty.');
    }
    if (!_.isNil(row.buyDownPercentageIndicator) && _.isNil(row.buyDownAmount)) {
      throw new Error('BuyDown Amount should be non-empty.');
    }
    if (!_.isNil(row.upSellPercentageIndicator) && _.isNil(row.upSellAmount)) {
      throw new Error('UpSell Amount should be non-empty.');
    }
    if (!_.isNil(row.upSellPercentageIndicator) && !_.isNil(row.upSellAmount)) {
      if (row.upSellPercentageIndicator && !row.upSellAmount.toString().match(regExp)) {
        throw new Error('UpSell Amount should be between 0 - 100 in case of percentage value');
      }
    }
    if (!_.isNil(row.buyDownPercentageIndicator) && !_.isNil(row.buyDownAmount)) {
      if (row.buyDownPercentageIndicator && !row.buyDownAmount.toString().match(regExp)) {
        throw new Error('Buydown Amount should be between 0 - 100 in case of percentage value');
      }
    }
  }
  function transformFOUpSellBuyDownConfigPayload(row) {
    if (!_.isNil(row.upSellPercentageIndicator)) {
      row.upSellPercentageIndicator = row.upSellPercentageIndicator === 'P' ? true : false;
    }
    if (!_.isNil(row.buyDownPercentageIndicator)) {
      row.buyDownPercentageIndicator = row.buyDownPercentageIndicator === 'P' ? true : false;
    }
    if (!_.isNil(row.foCabin)) {
      row.cabin = row.foCabin;
      delete row.foCabin;
    }
    try {
      validateFOUpSellBuyDownConfigPayloadBeforeSave(row);
    } catch (e) {
      throw e;
    }
    return row;
  }
  function transformFOCabinClassConfig(attrs, props, meta) {
    var propKey = 'cabinClassConfigPropertiesList';
    _.forEach(props[propKey], function (property) {
      property.foCabin = property.cabin;
    });
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTaxOverride(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    if (propKey === 'taxOverridePriority') {
      props.taxOverridePriority = props.taxOverridePriority.toUpperCase();
    } else {
      _.forEach(props[propKey], function (property) {
        property.fareType = property.fareType.toUpperCase();
        property.currencyCode = property.currencyCode.toUpperCase();
      });
    }
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareBrands(props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foFareBrands = [];
    _.forEach(props[propKey], function (foFareBrandProperty) {
      var foFareBrand = {};
      foFareBrand.carrier = foFareBrandProperty.carrier;
      foFareBrand.fareBrands = foFareBrandProperty.fareBrands;
      foFareBrands.push(_.assign(foFareBrand, meta));
    });
    return foFareBrands;
  }
  function transformFOMarketList(props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foMarketList = [];
    _.forEach(props[propKey], function (marketListProperty) {
      var foMarket = {};
      foMarket.hostCarrier = marketListProperty.hostCarrier;
      foMarket.originAirport = marketListProperty.origin;
      foMarket.destinationAirport = marketListProperty.destination;
      foMarket.foPos = marketListProperty.pos;
      foMarket.foCabin = marketListProperty.cabinCode;
      foMarket.benchmarkCarrier = marketListProperty.benchmarkCarrier.toString();
      foMarket.marketListCategory = marketListProperty.category;
      foMarket.marketTier = marketListProperty.marketTier;
      foMarket.fareChange = marketListProperty.fareChange;
      foMarket.adjustedTravelDates = marketListProperty.adjustedTravelDates;
      foMarket.approvedMarket = marketListProperty.approvedMarket;
      foMarket.checkEntryLevelFareChange = marketListProperty.checkEntryLevelFareChange;
      foMarket.approvedDaysOfWeek = marketListProperty.approvedDaysOfWeek;
      foMarket.exclusionReasons = marketListProperty.exclusionReasons;
      foMarket.hostFareTypeIndicator = marketListProperty.hostFareTypeIndicator;
      foMarket.benchmarkFareTypeIndicator = marketListProperty.benchmarkFareTypeIndicator;
      foMarket.fareSource = marketListProperty.fareSource;
      foMarket.minFareChangePercentage = marketListProperty.minFareChangePercentage;
      foMarket.maxFareChangePercentage = marketListProperty.maxFareChangePercentage;
      foMarketList.push(_.assign(foMarket, meta));
    });
    return foMarketList;
  }
  function transformFOTacticalFBCPatternConfig(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foTacticalFBCPatternRows = [];
    var extractedSeasonDetails = configurationParametersAdvancedService.extractSeasonDetails();
    _.forEach(props[propKey], function (tacticalFbcPatternProperties) {
      var foTacticalFbcPatternRow = {};
      foTacticalFbcPatternRow = _.cloneDeep(attrs);
      foTacticalFbcPatternRow.propertyValue = tacticalFbcPatternProperties.propertyValue;
      if (!_.isNil(foTacticalFbcPatternRow.propertyName) && foTacticalFbcPatternRow.propertyName === 'Season') {
        foTacticalFbcPatternRow.propValue = extractedSeasonDetails.seasonsAbbreviationMap[foTacticalFbcPatternRow.propertyValue.toUpperCase()];
      } else {
        foTacticalFbcPatternRow.propValue = foTacticalFbcPatternRow.propertyValue;
      }
      if (!_.isNil(tacticalFbcPatternProperties.tacticalFbcPatterns)) {
        foTacticalFbcPatternRow.tacticalFbcPatterns = buildFBCPatternProperties(tacticalFbcPatternProperties.tacticalFbcPatterns);
      }
      foTacticalFbcPatternRow.seasonDefinitions = extractedSeasonDetails.seasonDefinitions;
      foTacticalFbcPatternRow.seasons = extractedSeasonDetails.seasons;
      foTacticalFBCPatternRows.push(transformAttributeNameToFOAttributeName(_.assign(foTacticalFbcPatternRow, meta)));
    });
    return foTacticalFBCPatternRows;
  }
  function buildFBCPatternProperties(tacticalFBCPattern) {
    var fbcPatternProperties = [];
    _.forEach(tacticalFBCPattern, function (fbcPattern) {
      var foTacticalFBCPatternRow = {};
      foTacticalFBCPatternRow.fareSource = fbcPattern.competitorFareSource;
      foTacticalFBCPatternRow.position = fbcPattern.position;
      foTacticalFBCPatternRow.include = fbcPattern.include;
      foTacticalFBCPatternRow.exclude = fbcPattern.exclude;
      foTacticalFBCPatternRow.modifierFBC = fbcPattern.modifierFBC;
      fbcPatternProperties.push(foTacticalFBCPatternRow);
    });
    return fbcPatternProperties;
  }
  function transformFOTacticalFBCPatternConfigPayload(row) {
    var tacticalFBCPatternPropertyRow = [];
    var seasons = row.seasonDefinitions;
    _.forEach(row.tacticalFbcPatternProperties, function (eachTacticalFbcPatternProperty) {
      var propertyValue = eachTacticalFbcPatternProperty.propertyValue || row.propValue || '';
      if (row.propertyName === 'fareBrand') {
        propertyValue = propertyValue.toUpperCase();
      } else if (row.propertyName === 'Season') {
        propertyValue = _.find(seasons, {
          'season': propertyValue
        }).seasonAbbreviation;
      }
      var tacticalFbcPatternProperties = {};
      var tacticalFbcPatterns = [];
      _.forEach(eachTacticalFbcPatternProperty.tacticalFbcPatterns, function (eachTacticalFbcPattern) {
        var tacticalFbcPattern = {};
        if (!_.isNil(eachTacticalFbcPattern.fareSource)) {
          tacticalFbcPattern.competitorFareSource = eachTacticalFbcPattern.fareSource;
        }
        if (!_.isNil(eachTacticalFbcPattern.position)) {
          tacticalFbcPattern.position = eachTacticalFbcPattern.position;
        }
        if (!_.isNil(eachTacticalFbcPattern.include)) {
          tacticalFbcPattern.include = eachTacticalFbcPattern.include;
        }
        if (!_.isNil(eachTacticalFbcPattern.exclude)) {
          tacticalFbcPattern.exclude = eachTacticalFbcPattern.exclude;
        }
        tacticalFbcPattern.modifierFBC = eachTacticalFbcPattern.modifierFBC;
        tacticalFbcPatterns.push(tacticalFbcPattern);
      });
      tacticalFbcPatternProperties.propertyValue = propertyValue;
      tacticalFbcPatternProperties.tacticalFbcPatterns = tacticalFbcPatterns;
      tacticalFBCPatternPropertyRow.push(tacticalFbcPatternProperties);
    });
    row.tacticalFbcPatternProperties = tacticalFBCPatternPropertyRow;
    removeAdditionalKeys(row, ['seasonDefinitions', 'seasons', 'seasonsAbbreviationMap', 'propValue', 'propertyValue', 'tacticalFbcPatterns']);
    return convertFOAttributeNameToAttributeName(row, 'tacticalFbcPatternProperties');
  }
  function removeAdditionalKeys(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      delete row[keys[i]];
    }
  }
  function transformFORbdLevelFareThreshold(attrs, props, meta) {
    if (!_.isNil(props.override)) {
      props.override = props.override.toString().toUpperCase();
    }
    if (!_.isNil(props.foRBDLevelFareThresholdPropertiesList)) {
      buildRbdLevelThresholdProperties(props, attrs, meta);
    }
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function buildRbdLevelThresholdProperties(props, attrs, meta) {
    var rbdLevelFareThresholdProperties = [];
    _.forEach(props.foRBDLevelFareThresholdPropertiesList, function (property) {
      var rbdLevelFareThresholdPropertyRow = {};
      rbdLevelFareThresholdPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
      rbdLevelFareThresholdPropertyRow.foRbd = property.rbd;
      if (!_.isNil(property.minFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.minFareThreshold = property.minFareThreshold;
      }
      if (!_.isNil(property.maxFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.maxFareThreshold = property.maxFareThreshold;
      }
      if (!_.isNil(property.minFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.minFareThresholdPercent = property.minFareThresholdPercent;
      }
      if (!_.isNil(property.maxFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.maxFareThresholdPercent = property.maxFareThresholdPercent;
      }
      if (!_.isNil(attrs.origin)) {
        rbdLevelFareThresholdPropertyRow.origin = attrs.origin;
        rbdLevelFareThresholdPropertyRow.destination = attrs.destination;
      } else if (!_.isNil(attrs.pos)) {
        rbdLevelFareThresholdPropertyRow.pos = attrs.pos;
      }
      rbdLevelFareThresholdProperties.push(rbdLevelFareThresholdPropertyRow);
    });
    props.foRBDLevelFareThresholdPropertiesList = rbdLevelFareThresholdProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareClassMapping(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var fareClassMappingProperties = [];
    _.forEach(props[propKey], function (fareClassMapping) {
      var rbdsGroupedByCarrier = _.groupBy(fareClassMapping.competitorFareClassMappingList, 'competitorAirline');
      _.forEach(rbdsGroupedByCarrier, function (rbdGroupedByCarrier) {
        var foFareClassMapping = {};
        foFareClassMapping.fareSource = fareClassMapping.competitorFareSource;
        foFareClassMapping.fareTypeIndicator = fareClassMapping.fareTypeIndicator;
        foFareClassMapping.inventoryAssignmentMethod = fareClassMapping.inventoryAssignmentMethod;
        foFareClassMapping.ladderGenerationMethod = fareClassMapping.ladderGenerationMethod;
        foFareClassMapping.useForLadderGeneration = fareClassMapping.useForLadderGeneration;
        foFareClassMapping.hostEntryLevelRBD = fareClassMapping.hostEntryLevelRBD;
        foFareClassMapping.competitorAirline = rbdGroupedByCarrier[0].competitorAirline;
        if (!_.isNil(fareClassMapping.hostFareBrand)) {
          foFareClassMapping.hostFareBrand = fareClassMapping.hostFareBrand;
        }
        if (!_.isNil(rbdGroupedByCarrier[0].competitorFareBrand)) {
          foFareClassMapping.competitorFareBrand = rbdGroupedByCarrier[0].competitorFareBrand;
        }
        foFareClassMapping.competitorEntryLevelRbds = _.map(rbdGroupedByCarrier, 'competitorEntryLevelRBD').join(',');
        foFareClassMapping.origin = attrs.origin;
        foFareClassMapping.destination = attrs.destination;
        foFareClassMapping.cabin = attrs.cabin;
        foFareClassMapping.category = attrs.category;
        fareClassMappingProperties.push(foFareClassMapping);
      });
    });
    props[propKey] = fareClassMappingProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function getBenchmarkCarrierUpdatePayload(marketConfigRow, cabin) {
    return {
      type: 'FP_BenchmarkCarriers',
      hepKey: ['FP_BenchmarkCarriers', HOST_CARRIER, marketConfigRow.marketOrigin, marketConfigRow.marketDestination, cabin].join('.'),
      attributes: {
        marketDestination: marketConfigRow.marketDestination,
        marketOrigin: marketConfigRow.marketOrigin,
        cabinCode: cabin,
        carrier: HOST_CARRIER
      },
      properties: {
        benchmarkCarriers: marketConfigRow[getBenchmarkFieldName(cabin)]
      }
    };
  }
  function getBenchmarkCarrierDeletePayload(marketConfigRow, cabin) {
    return {
      type: 'FP_BenchmarkCarriers',
      hepKey: ['FP_BenchmarkCarriers', HOST_CARRIER, marketConfigRow.marketOrigin, marketConfigRow.marketDestination, cabin].join('.')
    };
  }
  function getMarketConfigRow(row, isExport) {
    var availableCabins = configurationService.getCabins();
    var benchmarkCarrierProperties = _.map(availableCabins, function (cabin) {
      return BENCHMARK_CARRIER_FIELD_PREFIX + cabin;
    });
    var shouldParseBoolean = function shouldParseBoolean(fieldName) {
      return fieldName !== 'isDynamicPricingAdj' && fieldName !== 'isMlModelEnabled' && fieldName !== 'isFareBrandEnabled' || fieldName === 'isDynamicPricingAdj' && featureToggleService.isEnabled('DYNAMIC_PRICING') || fieldName === 'isMlModelEnabled' && featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL') || fieldName === 'isFareBrandEnabled' && featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_FARE_BRAND');
    };
    var marketConfigRow = _.omit(row, benchmarkCarrierProperties);
    if (_.isNil(marketConfigRow['marketConfigParams_maxClassClosures'])) {
      marketConfigRow['marketConfigParams_maxClassClosures'] = 2;
    }
    if (_.isNil(marketConfigRow['marketConfigParams_isShiftShopping'])) {
      marketConfigRow['marketConfigParams_isShiftShopping'] = false;
    }
    if (!_.isNil(marketConfigRow['marketConfigParams_riaMethod']) && !isExport) {
      marketConfigRow['marketConfigParams_riaMethod'] = _.invert(RIA_METHOD_MAP)[marketConfigRow['marketConfigParams_riaMethod']];
    }
    if (!_.isNil(marketConfigRow['marketConfigParams_source']) && !isExport) {
      marketConfigRow['marketConfigParams_source'] = _.invert(MARKET_CONFIG_SOURCE_METHOD_MAP)[marketConfigRow['marketConfigParams_source']];
    }
    _.forEach(OPERATOR_NUMBER_PROPS, function (value, fieldName) {
      fpMarketConfigParsingService.mergeParsedNumber(marketConfigRow, 'marketConfigParams_' + fieldName);
    });
    _.forEach(marketConfigRow['marketConfigParams_blackoutDeptDateParams'], function (dateRow) {
      fpMarketConfigParsingService.mergeParsedDate(dateRow, 'start');
      fpMarketConfigParsingService.mergeParsedDate(dateRow, 'end');
    });
    _.forEach(marketConfigRow['marketConfigParams_dtdBlackout'], function (dateRow) {
      fpMarketConfigParsingService.mergeParsedNumber(dateRow, 'dtdCondition');
    });
    _.forEach(OPERATOR_BOOLEAN_PROPS, function (value, fieldName) {
      if (shouldParseBoolean(fieldName)) {
        fpMarketConfigParsingService.parseBoolean(marketConfigRow, 'marketConfigParams_' + fieldName);
      }
    });
    if (!marketConfigRow['marketConfigParams_isDynamicPricingAdj']) {
      delete marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'];
    }
    if (featureToggleService.isEnabled('DYNAMIC_PRICING') && marketConfigRow['marketConfigParams_isDynamicPricingAdj'] && _.isEmpty(marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'])) {
      marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'] = [{
        losStart: 0,
        losEnd: 330
      }];
    }
    if (!marketConfigRow['marketConfigParams_isMlModelEnabled']) {
      delete marketConfigRow['marketConfigParams_mlParams'];
    }
    if (!featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL')) {
      delete marketConfigRow['marketConfigParams_mlParams'];
      delete marketConfigRow['marketConfigParams_isMlModelEnabled'];
    }
    if (!featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_FARE_BRAND')) {
      delete marketConfigRow['marketConfigParams_isFareBrandEnabled'];
    }
    return marketConfigRow;
  }
  function getBenchmarkCarriersForUpdate(row) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      if (row[getBenchmarkFieldName(cabin)]) {
        result.push(getBenchmarkCarrierUpdatePayload(row, cabin));
      }
      return result;
    });
  }
  function getBenchmarkCarriersForDelete(row, editedOnly) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      var isDeletedFromRow = row[getBenchmarkFieldName(cabin)] === '' && row._old[getBenchmarkFieldName(cabin)];
      var isPresentInRow = row[getBenchmarkFieldName(cabin)];
      if (editedOnly ? isDeletedFromRow : isPresentInRow) {
        result.push(getBenchmarkCarrierDeletePayload(row, cabin));
      }
      return result;
    });
  }
  function addConnectionTimeOperators(row) {
    if (_.isNil(row['marketConfigParams_maxConnectionTime_value'])) {
      delete row['marketConfigParams_maxConnectionTime_operator'];
    } else {
      row['marketConfigParams_maxConnectionTime_operator'] = '>';
    }
    if (_.isNil(row['marketConfigParams_minConnectionTime_value'])) {
      delete row['marketConfigParams_minConnectionTime_operator'];
    } else {
      if (parseInt(row['marketConfigParams_minConnectionTime_value'], 10) === 0) {
        row['marketConfigParams_minConnectionTime_operator'] = '=';
      } else {
        row['marketConfigParams_minConnectionTime_operator'] = '<';
      }
    }
    return row;
  }
  function transformFpMarketConfigPayload(row, isExport) {
    row = addConnectionTimeOperators(row);
    var marketConfigRow = getMarketConfigRow(row, isExport);
    var modifyBenchmarkCarriers = getBenchmarkCarriersForUpdate(row);
    var deleteBenchmarkCarriers = getBenchmarkCarriersForDelete(row, true);
    return {
      marketConfigRow: marketConfigRow,
      modifyBenchmarkCarriers: modifyBenchmarkCarriers.length ? modifyBenchmarkCarriers : [],
      deleteBenchmarkCarriers: deleteBenchmarkCarriers.length ? deleteBenchmarkCarriers : []
    };
  }
  function transformFpTodHubBankConfigPayload(row) {
    var todTimeBands = row['todHubBankParams_todTimeBands'];
    row['todHubBankParams_todTimeBands'] = _.sortBy(todTimeBands, 'timeBandSequence');
    return row;
  }
  function transformFpMetroMarketPayload(row) {
    if (_.isNil(row['metroMarketParams_neighbors']) || _.isEmpty(row['metroMarketParams_neighbors'])) {
      throw new Error('Neighboring Markets should be specified in parameters.');
    }
    if (_.isNil(row['carrier'])) {
      row['carrier'] = HOST_CARRIER;
    }
    return row;
  }
  function transformCurtainRulePayload(row) {
    var availableCabins = configurationService.getCabins();
    _.forEach(row['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX] = {};
      _.forEach(availableCabins, function (cabinName) {
        var fieldName = getCabinCapacitiesFieldName(cabinName);
        if (!_.isNil(cabinOptionsRow[fieldName])) {
          cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName] = cabinOptionsRow[fieldName];
        }
        delete cabinOptionsRow[fieldName];
      });
    });
    calculateSeatFactorForRow(row);
    return row;
  }
  function convertFOAttributeNameToAttributeName(row, property) {
    if (!_.isNil(row.foCabin)) {
      row.cabin = row.foCabin;
      delete row.foCabin;
    }
    if (!_.isNil(row.foCarrier)) {
      row.carrier = row.foCarrier;
      delete row.foCarrier;
    }
    if (property !== undefined && row[property] === undefined) {
      row[property] = [];
    }
    return row;
  }
  function transformFOBusinessRulesPayload(row) {
    var templateBusinessRuleProperty = {
      'season': '',
      'benchmarkCarriers': [],
      'recommendationMatchType': ''
    };
    var businessRulesProperties = [];
    var foCategoryCabinRbdsMapping = configurationService.getFoCategoryCabinRbdsMapping();
    var categoryCabinRbdKey = configurationService.getFoCategoryCabinRbdMappingKey(row, foCategoryCabinRbdsMapping);
    _.forEach(row.businessRulesProperties, function (businessRulesProperty) {
      var inputRbds = businessRulesProperty.hostRbd ? businessRulesProperty.hostRbd.split(',') : [''];
      var possibleRbds = configurationService.getFoCategoryCabinRbds(row, foCategoryCabinRbdsMapping, categoryCabinRbdKey);
      possibleRbds = _.isEqual(possibleRbds, ['']) ? possibleRbds : _.concat([''], possibleRbds);
      var validRbds = _.intersection(inputRbds, possibleRbds);
      if (inputRbds.length !== 0 && validRbds.length !== inputRbds.length) {
        throw new Error([row.origin, row.destination, row.foCabin, row.category].join('.') + ' - found invalid RBDs');
      }
      var businessRuleProp = _.find(businessRulesProperties, {
        'season': businessRulesProperty.season
      });
      var benchmarkCarrier = {};
      benchmarkCarrier.normalizationIndicator = _.isNil(businessRulesProperty.normalizationIndicator) ? false : businessRulesProperty.normalizationIndicator;
      benchmarkCarrier.benchmarkCarrier = businessRulesProperty.benchmarkCarrier;
      benchmarkCarrier.fareTypeIndicator = businessRulesProperty.fareTypeIndicator;
      benchmarkCarrier.competitorFareSource = businessRulesProperty.fareSource;
      benchmarkCarrier.hostFareBrand = businessRulesProperty.hostFareBrand;
      benchmarkCarrier.hostRbd = businessRulesProperty.hostRbd;
      benchmarkCarrier.competitorFareBrand = businessRulesProperty.competitorFareBrand;
      benchmarkCarrier.strategy = businessRulesProperty.strategy;
      benchmarkCarrier.amount = businessRulesProperty.amount;
      benchmarkCarrier.benchmarkFareComponent = businessRulesProperty.benchmarkFareComponent;
      benchmarkCarrier.percentageIndicator = businessRulesProperty.percentageIndicator === 'P';
      if (!businessRuleProp) {
        businessRuleProp = _.cloneDeep(templateBusinessRuleProperty);
        businessRuleProp.season = businessRulesProperty.season;
      }
      businessRuleProp.benchmarkCarriers.push(benchmarkCarrier);
      businessRuleProp.recommendationMatchType = row.recommendationMatchType;
      if (!_.find(businessRulesProperties, {
        'season': businessRulesProperty.season
      })) {
        businessRulesProperties.push(businessRuleProp);
      }
    });
    row.businessRulesProperties = businessRulesProperties;
    removeAdditionalKeys(row, ['recommendationMatchType']);
    return convertFOAttributeNameToAttributeName(row, 'businessRulesProperties');
  }
  function transformFOCabinClassConfigPayload(row, property) {
    if (row[property] === undefined) {
      row[property] = [];
    }
    _.forEach(row.cabinClassConfigPropertiesList, function (property) {
      property.cabin = property.foCabin.toUpperCase();
      property.className = property.className.toUpperCase();
      if (property.fareBrand) {
        property.fareBrand = property.fareBrand.toUpperCase();
      }
      delete property.foCabin;
    });
    return convertFOAttributeNameToAttributeName(row, 'cabinClassConfigPropertiesList');
  }
  function transformFOAdvancePurchaseGrouping(attrs, props, meta) {
    if (!_.isNil(props.advancePurchaseGroupingProperty.ladderGenerationAPCheck)) {
      props.ladderGenerationAPCheck = props.advancePurchaseGroupingProperty.ladderGenerationAPCheck.toString().toUpperCase();
    }
    if (!_.isNil(props.advancePurchaseGroupingProperty.advancePurchaseGroupingProperties)) {
      var advancePurchaseGroupingProperties = [];
      _.forEach(props.advancePurchaseGroupingProperty.advancePurchaseGroupingProperties, function (property) {
        var advancePurchaseGroupingPropertyRow = {};
        advancePurchaseGroupingPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
        advancePurchaseGroupingPropertyRow.advancePurchaseStart = property.advancePurchaseStart;
        advancePurchaseGroupingPropertyRow.advancePurchaseEnd = property.advancePurchaseEnd;
        if (!_.isNil(property.predefinedAP)) {
          advancePurchaseGroupingPropertyRow.predefinedAP = property.predefinedAP;
        }
        advancePurchaseGroupingProperties.push(advancePurchaseGroupingPropertyRow);
      });
    }
    props.advancePurchaseGroupingProperties = advancePurchaseGroupingProperties;
    delete props.advancePurchaseGroupingProperty;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOAdvancePurchaseGroupingPayload(row) {
    var advancePurchaseGroupingProperty = {};
    if (!_.isNil(row.ladderGenerationAPCheck)) {
      row.ladderGenerationAPCheck = row.ladderGenerationAPCheck === 'TRUE' || row.ladderGenerationAPCheck === 'FALSE' ? JSON.parse(row.ladderGenerationAPCheck.toLowerCase()) : undefined;
      advancePurchaseGroupingProperty.ladderGenerationAPCheck = row.ladderGenerationAPCheck;
    }
    var advancePurchaseGroupingProperties = [];
    _.forEach(row.advancePurchaseGroupingProperties, function (property) {
      var advancePurchaseGroupingPropertyRow = {};
      advancePurchaseGroupingPropertyRow.advancePurchaseStart = property.advancePurchaseStart;
      advancePurchaseGroupingPropertyRow.advancePurchaseEnd = property.advancePurchaseEnd;
      advancePurchaseGroupingPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
      if (!_.isNil(property.predefinedAP)) advancePurchaseGroupingPropertyRow.predefinedAP = property.predefinedAP;
      advancePurchaseGroupingProperties.push(advancePurchaseGroupingPropertyRow);
    });
    delete row.ladderGenerationAPCheck;
    delete row.advancePurchaseGroupingProperties;
    advancePurchaseGroupingProperty.advancePurchaseGroupingProperties = advancePurchaseGroupingProperties;
    row.advancePurchaseGroupingProperty = advancePurchaseGroupingProperty;
    return convertFOAttributeNameToAttributeName(row, 'advancePurchaseGroupingProperty');
  }
  function transformFONoticePeriodType(attrs, props, meta) {
    _.forEach(props.noticePeriodProperties, function (noticePeriodProperty) {
      if (!_.isNil(noticePeriodProperty.userIds)) {
        noticePeriodProperty.userName = noticePeriodProperty.userIds;
        delete noticePeriodProperty.userIds;
      }
    });
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFONoticePeriodPayload(row) {
    var noticePeriodProperties = [];
    _.forEach(row.noticePeriodProperties, function (noticePeriodProperty) {
      var noticePeriodPropertyRow = {};
      if (!_.isNil(noticePeriodProperty.fareChangeDirection)) {
        noticePeriodPropertyRow.fareChangeDirection = noticePeriodProperty.fareChangeDirection;
      }
      if (!_.isNil(noticePeriodProperty.excludedDaysOfWeek)) {
        noticePeriodPropertyRow.excludedDaysOfWeek = noticePeriodProperty.excludedDaysOfWeek;
      }
      if (!_.isNil(noticePeriodProperty.userName)) {
        noticePeriodPropertyRow.userIds = noticePeriodProperty.userName;
      }
      noticePeriodPropertyRow.noticePeriod = noticePeriodProperty.noticePeriod;
      noticePeriodProperties.push(noticePeriodPropertyRow);
    });
    row.noticePeriodProperties = noticePeriodProperties;
    return convertFOAttributeNameToAttributeName(row, 'noticePeriodProperties');
  }
  function transformFOViaPoints(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOViaPointsPayload(row) {
    var viaPointsProperties = [];
    _.forEach(row.viaPointsProperties, function (viaPointsProperty) {
      var viaPointsPropertyRow = {};
      viaPointsPropertyRow.routingNumber = viaPointsProperty.routingNumber;
      if (!_.isNil(viaPointsProperty.connectionOutbound)) {
        viaPointsPropertyRow.connectionOutbound = viaPointsProperty.connectionOutbound;
      }
      if (!_.isNil(viaPointsProperty.carrierOutbound)) {
        viaPointsPropertyRow.carrierOutbound = viaPointsProperty.carrierOutbound;
      }
      if (!_.isNil(viaPointsProperty.connectionInbound)) {
        viaPointsPropertyRow.connectionInbound = viaPointsProperty.connectionInbound;
      }
      if (!_.isNil(viaPointsProperty.carrierInbound)) {
        viaPointsPropertyRow.carrierInbound = viaPointsProperty.carrierInbound;
      }
      viaPointsProperties.push(viaPointsPropertyRow);
    });
    row.viaPointsProperties = viaPointsProperties;
    return convertFOAttributeNameToAttributeName(row, 'viaPointsProperties');
  }
  function transformFORbdLevelFareThresholdPayload(row) {
    if (!_.isNil(row.override)) {
      row.override = row.override === 'TRUE' || row.override === 'FALSE' ? JSON.parse(row.override.toLowerCase()) : undefined;
    }
    if (!_.isNil(row.foRBDLevelFareThresholdPropertiesList)) {
      transformRbdLevelThresholdProperties(row);
    }
    return convertFOAttributeNameToAttributeName(row);
  }
  function transformRbdLevelThresholdProperties(row) {
    var rbdLevelFareThresholdProperties = [];
    _.forEach(row.foRBDLevelFareThresholdPropertiesList, function (rbdLevelFareThresholdProperty) {
      var rbdLevelFareThresholdPropertyRow = {};
      rbdLevelFareThresholdPropertyRow.fareTypeIndicator = rbdLevelFareThresholdProperty.fareTypeIndicator;
      rbdLevelFareThresholdPropertyRow.rbd = rbdLevelFareThresholdProperty.foRbd;
      if (!_.isNil(rbdLevelFareThresholdProperty.minFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.minFareThreshold = rbdLevelFareThresholdProperty.minFareThreshold;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.maxFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.maxFareThreshold = rbdLevelFareThresholdProperty.maxFareThreshold;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.minFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.minFareThresholdPercent = rbdLevelFareThresholdProperty.minFareThresholdPercent;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.maxFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.maxFareThresholdPercent = rbdLevelFareThresholdProperty.maxFareThresholdPercent;
      }
      rbdLevelFareThresholdProperties.push(rbdLevelFareThresholdPropertyRow);
    });
    row.foRBDLevelFareThresholdPropertiesList = rbdLevelFareThresholdProperties;
    return convertFOAttributeNameToAttributeName(row, 'foRBDLevelFareThresholdPropertiesList');
  }
  function transformFOInputDataComparisonChecksType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var inputDataComparisonChecksProperties = [];
    _.forEach(props[propKey], function (inputDataComparisonChecks) {
      _.forEach(inputDataComparisonChecks.inputSourceSpecificProperties, function (property) {
        var foInputDataComparisonChecks = {};
        foInputDataComparisonChecks.inputSource = inputDataComparisonChecks.inputSource;
        if (!_.isNil(property.inputType)) {
          foInputDataComparisonChecks.inputType = property.inputType;
        }
        if (!_.isNil(property.absoluteChange)) {
          foInputDataComparisonChecks.absoluteChange = property.absoluteChange;
        }
        if (!_.isNil(property.percentageChange)) {
          foInputDataComparisonChecks.percentageChange = property.percentageChange;
        }
        inputDataComparisonChecksProperties.push(foInputDataComparisonChecks);
      });
    });
    props[propKey] = inputDataComparisonChecksProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOInputDataComparisonChecksPayload(row) {
    var inputDataComparisonChecks = [];
    var groupingByInputSource = _.groupBy(row.inputDataComparisonChecksProperties, 'inputSource');
    _.forEach(groupingByInputSource, function (entry) {
      var propertyRow = {};
      propertyRow.inputSource = entry[0].inputSource;
      propertyRow.inputSourceSpecificProperties = getInputSourceSpecificProperties(groupingByInputSource[entry[0].inputSource]);
      inputDataComparisonChecks.push(propertyRow);
    });
    row.inputDataComparisonChecksProperties = inputDataComparisonChecks;
    return convertFOAttributeNameToAttributeName(row, 'inputDataComparisonChecksProperties');
  }
  function getInputSourceSpecificProperties(propertiesGroupedByInputSource) {
    var inputSourceSpecificProperties = [];
    _.forEach(propertiesGroupedByInputSource, function (property) {
      var inputSourceSpecificPropertyRow = {};
      inputSourceSpecificPropertyRow.inputType = property.inputType;
      inputSourceSpecificPropertyRow.absoluteChange = property.absoluteChange;
      inputSourceSpecificPropertyRow.percentageChange = property.percentageChange;
      inputSourceSpecificProperties.push(inputSourceSpecificPropertyRow);
    });
    return inputSourceSpecificProperties;
  }
  function transformFOFareClassMappingPayLoad(row) {
    var fareClassMappingProperties = [];
    var groupingByCompFareSource = _.groupBy(row.fareClassMappingProperties, 'fareSource');
    _.forEach(_.keys(groupingByCompFareSource), function (cpmFareSource) {
      var groupingByFareTypeIndicator = _.groupBy(groupingByCompFareSource[cpmFareSource], 'fareTypeIndicator');
      _.forEach(_.keys(groupingByFareTypeIndicator), function (fareTypeIndicator) {
        var groupingByEntryLevelRbd = _.groupBy(groupingByFareTypeIndicator[fareTypeIndicator], 'hostEntryLevelRBD');
        _.forEach(groupingByEntryLevelRbd, function (hostEntries) {
          var groupingByHostFareBrand = _.groupBy(hostEntries, 'hostFareBrand');
          _.forEach(groupingByHostFareBrand, function (entry) {
            var propertyRow = {};
            propertyRow.fareTypeIndicator = fareTypeIndicator;
            if (row.category === 'TACTICAL' && entry[0].inventoryAssignmentMethod !== 'ENTRY LEVEL RBD' && entry[0].inventoryAssignmentMethod !== 'RBD TO RBD') {
              throw new Error('For TACTICAL category, Inventory Assignment Method must be ENTRY LEVEL RBD or RBD TO RBD');
            }
            propertyRow.competitorFareSource = entry[0].fareSource;
            propertyRow.inventoryAssignmentMethod = entry[0].inventoryAssignmentMethod;
            propertyRow.ladderGenerationMethod = entry[0].ladderGenerationMethod;
            propertyRow.useForLadderGeneration = entry[0].useForLadderGeneration;
            propertyRow.hostEntryLevelRBD = entry[0].hostEntryLevelRBD.toUpperCase();
            if (!_.isEmpty(entry[0].hostFareBrand)) {
              propertyRow.hostFareBrand = entry[0].hostFareBrand;
            }
            propertyRow.competitorFareClassMappingList = getCompetitorFareClassMappingList(groupingByHostFareBrand[entry[0].hostFareBrand]);
            fareClassMappingProperties.push(propertyRow);
          });
        });
      });
    });
    row.fareClassMappingProperties = mergeFareClassMappingOnBasisOfFareSource(fareClassMappingProperties);
    return convertFOAttributeNameToAttributeName(row, 'fareClassMappingProperties');
  }
  function mergeFareClassMappingOnBasisOfFareSource(fareClassMappingProperties) {
    var mergedFareClassMapping = [];
    _.forEach(fareClassMappingProperties, function (eachFareClassMapping) {
      var merged = false;
      for (var i = 0; i < mergedFareClassMapping.length; i++) {
        var value = mergedFareClassMapping[i];
        if (isFareClassMappingPropertiesSameExceptFareSource(value, eachFareClassMapping)) {
          var fareSources = _.union(value.competitorFareSource.split(','), eachFareClassMapping.competitorFareSource.split(','));
          value.competitorFareSource = _.join(_.uniq(fareSources).sort());
          merged = true;
          break;
        }
      }
      if (!merged) {
        mergedFareClassMapping.push(eachFareClassMapping);
      }
    });
    return mergedFareClassMapping;
  }
  function isFareClassMappingPropertiesSameExceptFareSource(first, second) {
    return _.isEqual(first.fareTypeIndicator, second.fareTypeIndicator) && _.isEqual(first.inventoryAssignmentMethod, second.inventoryAssignmentMethod) && _.isEqual(first.ladderGenerationMethod, second.ladderGenerationMethod) && _.isEqual(first.useForLadderGeneration, second.useForLadderGeneration) && _.isEqual(first.hostEntryLevelRBD, second.hostEntryLevelRBD) && _.isEqual(first.hostFareBrand, second.hostFareBrand) && _.isEqual(first.competitorFareClassMappingList, second.competitorFareClassMappingList);
  }
  function getCompetitorFareClassMappingList(competitorMappingPerRbd) {
    var competitorFareClassMappingList = [];
    _.forEach(competitorMappingPerRbd, function (competitorMapping) {
      if (!areCompRbdsDefined(competitorMapping.competitorEntryLevelRbds)) {
        var competitorMappingRow = {};
        competitorMappingRow.competitorFareBrand = competitorMapping.competitorFareBrand;
        competitorMappingRow.competitorAirline = competitorMapping.competitorAirline.toUpperCase();
        competitorMappingRow.competitorEntryLevelRBD = null;
        competitorFareClassMappingList.push(competitorMappingRow);
      } else {
        var competitorEntryLevelRbds = competitorMapping.competitorEntryLevelRbds.toUpperCase().split(',');
        _.forEach(_.uniq(competitorEntryLevelRbds), function (competitorRbd) {
          var competitorMappingRow = {};
          competitorMappingRow.competitorFareBrand = competitorMapping.competitorFareBrand;
          competitorMappingRow.competitorAirline = competitorMapping.competitorAirline.toUpperCase();
          competitorMappingRow.competitorEntryLevelRBD = competitorRbd.toUpperCase();
          competitorFareClassMappingList.push(competitorMappingRow);
        });
      }
    });
    return _.uniqWith(competitorFareClassMappingList, _.isEqual);
  }
  function areCompRbdsDefined(compRbds) {
    return !_.isNil(compRbds);
  }
  function calculateSeatFactorForRow(row) {
    var availableCabins = configurationService.getCabins();
    var lowestCabin = _.last(availableCabins);
    var intermediateCabinData = [];
    _.forEach(row['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      _.forEach(availableCabins, function (cabinName) {
        if (cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName] && cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][lowestCabin] && cabinName !== lowestCabin) {
          var obj = {};
          obj[cabinName] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName];
          obj[lowestCabin] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][lowestCabin];
          if (!intermediateCabinData[cabinName]) {
            intermediateCabinData[cabinName] = [];
          }
          intermediateCabinData[cabinName].push(obj);
        }
      });
    });
    row['curtainRuleParam_physicalSeatFactors'] = calculateSeatFactor(intermediateCabinData, lowestCabin);
    return row;
  }
  function calculateSeatFactor(intermediateCabinData, lowestCabin) {
    var seatFactors = {};
    seatFactors[lowestCabin] = 1;
    _.forIn(intermediateCabinData, function (cabinData, cabinName) {
      if (cabinData.length === 1) {
        seatFactors[cabinName] = 1;
      } else {
        cabinData = _.sortBy(cabinData, [lowestCabin]);
        var prevOption = _.head(cabinData);
        cabinData = _.tail(cabinData);
        var cabinSeatFactors = [];
        _.forIn(cabinData, function (option) {
          if (option[cabinName] - prevOption[cabinName] !== 0) {
            cabinSeatFactors.push((prevOption[lowestCabin] - option[lowestCabin]) / (option[cabinName] - prevOption[cabinName]));
          }
          prevOption = option;
        });
        seatFactors[cabinName] = _.mean(cabinSeatFactors);
      }
    });
    return seatFactors;
  }
  function transformBooleanValues(row) {
    _.forOwn(row, function (value, key) {
      if (_.isBoolean(value)) {
        row[key] = transformBoolean(value);
      }
    });
  }
  function transformNumberAttributes(attributes, meta) {
    if (meta === 'DA_BookingVelocityPPSAdjustment') {
      _.forOwn(attributes, function (value, key) {
        if (key !== 'cabinCode' && key !== 'legOrigin' && key !== 'legDestination' && key !== 'travelDateBegin' && key !== 'travelDateEnd' && key !== 'bvDeviationType') {
          attributes[key] = _.toInteger(value);
        }
      });
    }
  }
  function isOverlapping(range1, range2) {
    var from1 = range1.start;
    var to1 = range1.stop;
    var from2 = range2.start;
    var to2 = range2.stop;
    return to1 >= from2 && from1 <= to2;
  }
  function checkOverlapping(entries) {
    for (var i = 0; i < entries.length; i++) {
      for (var j = i + 1; j < entries.length; j++) {
        if (isOverlapping(entries[i], entries[j])) {
          return true;
        }
      }
    }
    return false;
  }
  function convertTimeOfDayDefinitionToString(row, foTacticalFareBrandUserOverrideProperty) {
    var inboundTimeOfDayDefinition = [];
    var outboundTimeOfDayDefinition = [];
    var inboundWeekendDefinition = foTacticalFareBrandUserOverrideProperty.inboundWeekendDefinition;
    var outboundWeekendDefinition = foTacticalFareBrandUserOverrideProperty.outboundWeekendDefinition;
    _.forEach(foTacticalFareBrandUserOverrideProperty.timeOfDayPropertiesList, function (timeOfDay) {
      var todProperties = {};
      todProperties.start = timeOfDay.start.replace(/^\s*|\s*$/g, '');
      todProperties.stop = timeOfDay.stop.replace(/^\s*|\s*$/g, '');
      var direction = timeOfDay.inOrOutBoundType === 'IB' ? 'Inbound' : 'Outbound';
      if (timeOfDay.inOrOutBoundType === 'IB') {
        checkIsStartGreaterThanStopTimeOfDayWeek(inboundWeekendDefinition, todProperties, direction, row);
        inboundTimeOfDayDefinition.push(todProperties);
      } else {
        checkIsStartGreaterThanStopTimeOfDayWeek(outboundWeekendDefinition, todProperties, direction, row);
        outboundTimeOfDayDefinition.push(todProperties);
      }
    });
    if (checkOverlapping(inboundTimeOfDayDefinition)) {
      throw new Error('Overlapping Inbound Time Of Day');
    }
    if (checkOverlapping(outboundTimeOfDayDefinition)) {
      throw new Error('Overlapping Outbound Time Of Day');
    }
    if (!_.isEmpty(inboundTimeOfDayDefinition)) {
      foTacticalFareBrandUserOverrideProperty.inboundTimeOfDayDefinition = inboundTimeOfDayDefinition;
    }
    if (!_.isEmpty(outboundTimeOfDayDefinition)) {
      foTacticalFareBrandUserOverrideProperty.outboundTimeOfDayDefinition = outboundTimeOfDayDefinition;
    }
    delete foTacticalFareBrandUserOverrideProperty.timeOfDayPropertiesList;
  }
  function checkIsStartGreaterThanStopTimeOfDayWeek(weekendDefinition, todProperties, direction, row) {
    if (_.isEmpty(weekendDefinition) || weekendDefinition.split(',').length === 1) {
      if (todProperties.start > todProperties.stop) {
        throw new Error(row.hepKey.substring(row.hepKey.indexOf('.') + 1) + ' - ' + direction + ' Time of day Start should be less than Stop');
      }
    }
  }
  function buildTimeOfDayProperties(props, fieldName) {
    var inOrOutBoundType = fieldName === 'inboundTimeOfDayDefinition' ? 'IB' : 'OB';
    var timeOfDayDefinition = _.map(props[fieldName], function (tod) {
      return {
        inOrOutBoundType: inOrOutBoundType,
        start: tod['start'].toString(),
        stop: tod['stop'].toString()
      };
    });
    return timeOfDayDefinition;
  }
  function transformDAFareFloorPayload(row) {
    var transformedRow = _.clone(row);
    transformedRow.fareFloorCeilingParams = {
      minFare: transformedRow.minFare,
      maxFare: transformedRow.maxFare
    };
    delete transformedRow.minFare;
    delete transformedRow.maxFare;
    return transformedRow;
  }
  function transformDAFareFloor(attrs, props, meta) {
    return _.merge({
      minFare: _.get(props, 'fareFloorCeilingParams.minFare'),
      maxFare: _.get(props, 'fareFloorCeilingParams.maxFare')
    }, attrs, meta);
  }
  return {
    transformFpMarketConfigType: transformFpMarketConfigType,
    transformFpMarketConfigPayload: transformFpMarketConfigPayload,
    transformFpTodHubBankConfigPayload: transformFpTodHubBankConfigPayload,
    transformFpMetroMarketPayload: transformFpMetroMarketPayload,
    getBenchmarkCarriersForDelete: getBenchmarkCarriersForDelete,
    transformCurtainRuleType: transformCurtainRuleType,
    transformCurtainRulePayload: transformCurtainRulePayload,
    transformBooleanValues: transformBooleanValues,
    transformNumberAttributes: transformNumberAttributes,
    transformFOBusinessRulesType: transformFOBusinessRulesType,
    transformFOBusinessRulesPayload: transformFOBusinessRulesPayload,
    transformFOMarketList: transformFOMarketList,
    transformFOFareBrands: transformFOFareBrands,
    transformFOCabinClassConfig: transformFOCabinClassConfig,
    transformFOCabinClassConfigPayload: transformFOCabinClassConfigPayload,
    transformFOUpSellBuyDownConfigPayload: transformFOUpSellBuyDownConfigPayload,
    transformFOUpSellBuyDownConfig: transformFOUpSellBuyDownConfig,
    convertFOAttributeNameToAttributeName: convertFOAttributeNameToAttributeName,
    transformAttributeNameToFOAttributeName: transformAttributeNameToFOAttributeName,
    transformFORbdLevelFareThresholdPayload: transformFORbdLevelFareThresholdPayload,
    transformFONoticePeriodType: transformFONoticePeriodType,
    transformFONoticePeriodPayload: transformFONoticePeriodPayload,
    transformFOAdvancePurchaseGrouping: transformFOAdvancePurchaseGrouping,
    transformFOAdvancePurchaseGroupingPayload: transformFOAdvancePurchaseGroupingPayload,
    transformFOViaPoints: transformFOViaPoints,
    transformFOViaPointsPayload: transformFOViaPointsPayload,
    transformFOInputDataComparisonChecksType: transformFOInputDataComparisonChecksType,
    transformFOInputDataComparisonChecksPayload: transformFOInputDataComparisonChecksPayload,
    transformFORbdLevelFareThreshold: transformFORbdLevelFareThreshold,
    transformFOFareClassMapping: transformFOFareClassMapping,
    transformFOFareClassMappingPayLoad: transformFOFareClassMappingPayLoad,
    transformFOTaxOverride: transformFOTaxOverride,
    transformFOPosAnalystMapType: transformFOPosAnalystMapType,
    transformFOPosAnalystMapPayload: transformFOPosAnalystMapPayload,
    transformFOTacticalFBCPatternConfig: transformFOTacticalFBCPatternConfig,
    transformFOTacticalFBCPatternConfigPayload: transformFOTacticalFBCPatternConfigPayload,
    transformFOTacticalFareIndexType: transformFOTacticalFareIndexType,
    transformFOTacticalFareIndexPayload: transformFOTacticalFareIndexPayload,
    transformFOTacticalUserOverridesType: transformFOTacticalUserOverridesType,
    transformFOTacticalUserOverridesPayload: transformFOTacticalUserOverridesPayload,
    transformFOFareBrandAssignmentPayload: transformFOFareBrandAssignmentPayload,
    transformFOTacticalFareDefinitionPayload: transformFOTacticalFareDefinitionPayload,
    transformFOTacticalFareDefinition: transformFOTacticalFareDefinition,
    transformFOFareBrandAssignment: transformFOFareBrandAssignment,
    transformDAFareFloorPayload: transformDAFareFloorPayload,
    transformDAFareFloor: transformDAFareFloor
  };
};
AdvancedHepTransformationService.$inject = ['ConfigurationService', 'FpMarketConfigParsingService', 'MomentService', 'FeatureToggleService', 'ConfigurationParametersAdvancedService'];
module.exports = AdvancedHepTransformationService;